import PortalIdParser from 'PortalIdParser';
import apiClient from '../utils/SPMRedirectNoAuthApiClient';
const BASE_URL = 'meetings-public/v1';
export const fetchMeetingLink = userId => apiClient.get(`${BASE_URL}/link/default`, {
  query: {
    portalId: PortalIdParser.get(),
    userId
  }
});